import { STORAGE_KEYS } from '@/utils/storageKeys'

/** Alinhado com AuthController::ACCESS_TOKEN_TTL_SECONDS */
export const DEFAULT_ACCESS_TOKEN_TTL_SECONDS = 900

/** Janela de aviso antes da expiração (fallback) */
export const DEFAULT_WARN_BEFORE_SECONDS = 120

/** Timeout de sessão padrão (8h) — alinhado ao panel_settings */
export const DEFAULT_SESSION_TIMEOUT_SECONDS = 480 * 60

const STORAGE_KEY = STORAGE_KEYS.SESSION_META

function readRaw() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (raw) {
      return JSON.parse(raw)
    }
  } catch {
    /* ignore */
  }
  return {}
}

function writeRaw(data) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data))
  } catch {
    /* ignore */
  }
}

function normalizeMeta(raw = {}) {
  const accessTtl = Number(raw.access_token_ttl_seconds ?? raw.accessTokenTtlSeconds)
  const warnBefore = Number(raw.warn_before_seconds ?? raw.warnBeforeSeconds)
  const sessionTimeout = Number(raw.session_timeout_seconds ?? raw.sessionTimeoutSeconds)
  const refreshExpiresAt = raw.refresh_expires_at ?? raw.refreshExpiresAt ?? null
  const lastActivityAt = raw.last_activity_at ?? raw.lastActivityAt ?? null

  return {
    accessTokenTtlSeconds: Number.isFinite(accessTtl) && accessTtl > 0
      ? accessTtl
      : DEFAULT_ACCESS_TOKEN_TTL_SECONDS,
    warnBeforeSeconds: Number.isFinite(warnBefore) && warnBefore > 0
      ? warnBefore
      : DEFAULT_WARN_BEFORE_SECONDS,
    sessionTimeoutSeconds: Number.isFinite(sessionTimeout) && sessionTimeout > 0
      ? sessionTimeout
      : null,
    refreshExpiresAt: typeof refreshExpiresAt === 'string' && refreshExpiresAt
      ? refreshExpiresAt
      : null,
    lastActivityAt: typeof lastActivityAt === 'string' && lastActivityAt
      ? lastActivityAt
      : null,
  }
}

export function setSessionMeta(meta) {
  if (!meta || typeof meta !== 'object') return

  const merged = { ...readRaw(), ...meta }
  if (!merged.last_activity_at && !merged.lastActivityAt) {
    merged.last_activity_at = new Date().toISOString()
  }

  writeRaw(merged)
}

export function getSessionMeta() {
  return normalizeMeta(readRaw())
}

export function clearSessionMeta() {
  localStorage.removeItem(STORAGE_KEY)
}

export function touchSessionActivity() {
  const merged = readRaw()
  merged.last_activity_at = new Date().toISOString()
  writeRaw(merged)
}

export function resetSessionActivity() {
  touchSessionActivity()
}

export function getWarnBeforeSeconds() {
  return getSessionMeta().warnBeforeSeconds
}

export function getRefreshExpiresAtMs() {
  const iso = getSessionMeta().refreshExpiresAt
  if (!iso) return null
  const ms = Date.parse(iso)
  return Number.isFinite(ms) ? ms : null
}

/** Tempo restante de inatividade (segundos) com base em session_timeout + última atividade. */
export function getIdleTimeLeftSec() {
  const meta = getSessionMeta()
  const timeout = meta.sessionTimeoutSeconds ?? meta.accessTokenTtlSeconds
  if (!timeout) return null

  const lastAt = meta.lastActivityAt
  if (!lastAt) {
    return timeout
  }

  const elapsed = Math.floor((Date.now() - Date.parse(lastAt)) / 1000)
  return Math.max(0, timeout - elapsed)
}
